// src/index.ts
import * as shvl from "shvl";
function src_default(context) {
  const { options: { persist }, store } = context;
  if (!persist)
    return;
  const {
    storage = localStorage,
    key = store.$id,
    paths = null,
    overwrite = false
  } = typeof persist != "boolean" ? persist : {};
  try {
    const fromStorage = storage.getItem(key);
    if (fromStorage) {
      if (overwrite)
        store.$state = JSON.parse(fromStorage);
      else
        store.$patch(JSON.parse(fromStorage));
    }
  } catch (_error) {
  }
  store.$subscribe((_mutation, state) => {
    try {
      const toStore = Array.isArray(paths) ? paths.reduce((substate, path) => {
        return shvl.set(substate, path, shvl.get(state, path));
      }, {}) : state;
      storage.setItem(key, JSON.stringify(toStore));
    } catch (_error) {
    }
  });
}
export {
  src_default as default
};
